import { request } from '@/utils/request';

// 医疗知识库详情
export function byIdSyKb(id,token) {
    return request({
      url: `/literature/syKb/getById/${id}`,
      method: 'get',
      // headers: {
      //   Authorization: `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoxNywidXNlcl9pZCI6MTI4LCJvcmdfaWQiOjAsInVzZXJfa2V5IjoiNmVmZThhNzktMGYyYS00Njc5LWI2ZWMtMWZmYzg3ZmY2YWMyIiwiZGV2aWNlX3R5cGUiOiJBZG1pbiIsInVzZXJuYW1lIjoiMTMxMjM0NTY3ODkifQ.2wAE2Gto8Azc_EcIXzmTStvoSJtyRWBBd4l2TZPQkOMVuyhPrT54xvlynEMvxVzQlC26yxLlGAYn8ay8DR6McQ`
      // }
    headers: {
        Authorization: `Bearer ${token}` // 使用Bearer token格式
      }
    })
  }
